
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class DetailClaim extends Vue {
  @Prop() detailClaim!: string;
}
